import './contributionManagmentCancelView.scss';
// @vendors
import React, { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
const { withRouter } = require('react-router-dom');
// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
// @commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKButton } = require('commonsComponents/OKButton');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { LoadingSection } = require('commonsComponents/loadingSection');
const BrokerTruncatedBreadcrumb = require('components/broker/brokerTruncatedBreadcrumb/brokerTruncatedBreadcrumb');
// @components
import ContributionManagmentCancelSuccess from './components/ContributionManagmentCancelSuccess';
import ContributionManagmentCancelContent from './components/ContributionManagmentCancelContent';
// @ actions
import BrokerPeriodicalFundsContributionsActions from 'actions/brokerPeriodicalFundsContributions';
// @contants
const { BROKER_PG_URL } = require('constants/index');

const ContributionManagmentCancelView = ({
  immBrokerPeriodicalFundsContributions,
  immBrokerMyInvestments,
  fetchPeriodicalContributions,
  resetCancelPeriodicalContribution,
  match: {
    params: { productCode, contractNumber },
  },
  history,
}) => {
  const periodicalContributionSelected = immBrokerPeriodicalFundsContributions.get(
      'periodicalContributionSelected'
    );
  const cancelPeriodicalContributionSuccess = immBrokerPeriodicalFundsContributions.get(
  'cancelPeriodicalContributionSuccess'
  );
  const fetching = immBrokerPeriodicalFundsContributions.get('fetching');

  useEffect(() => {
    return () => resetCancelPeriodicalContribution();
  }, []);

  useEffect(() => {

    if (!periodicalContributionSelected) {
        fetchPeriodicalContributions(productCode, contractNumber);
    }
  }, [cancelPeriodicalContributionSuccess, periodicalContributionSelected, immBrokerMyInvestments.get('fetchSuccess')]);

  const breadcrumbData = [
    {
      text: formatText('brokerWealth-contributionManagmentBreadCrumbFirstItem'),
      url: '/myprofile/broker',
    },
    {
      text: formatText('breadcrumbWealth-contributionManagment'),
      url: '/myprofile/broker/contributionManagment',
    },
    {
      text: formatText('brokerWealth-contributionManagmentBreadCrumbCancelTitle'),
    },
  ];

  const buildFetching = () => {
    return (
        <OKSectionBox>
            <LoadingSection />
        </OKSectionBox>
    );
  }

  const content = useMemo(() => {
    return cancelPeriodicalContributionSuccess ? (
        <ContributionManagmentCancelSuccess />
      ) : (
        <ContributionManagmentCancelContent />
      );
  },[cancelPeriodicalContributionSuccess])

  return (
    <div>
      <div className="container-fluid">
        <div className="row">
          <OKCover size="medium" section="broker">
            <BrokerTruncatedBreadcrumb
              titleKey={'brokerWealth-contributionManagmentBreadCrumbCancelTitle'}
              breadcrumbConfig={breadcrumbData}
            >
              <OKButton
                inverse={true}
                modifier="ghost"
                onClick={() => history.replace(BROKER_PG_URL)}
              >
                <FormattedText value={'brokerWealth-contributionManagmentBreadCrumbButtonText'} />
              </OKButton>
            </BrokerTruncatedBreadcrumb>
          </OKCover>
        </div>
      </div>
      <div className="grid-view__body">
        <div className="container-fluid">
          <div className="row container-cancel-contribution-managment-view">
            <div className="col-xs-12">
                {fetching ? buildFetching() : content}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ContributionManagmentCancelView.propTypes = {
    immBrokerPeriodicalFundsContributions: PropTypes.object.isRequired,
    fetchPeriodicalContributions: PropTypes.func.isRequired,
};

module.exports.constructor = ContributionManagmentCancelView;
module.exports.ContributionManagmentCancelView = withRouter(
  connect(
    state => ({
        immBrokerMyInvestments: state.brokerMyInvestments,
        immBrokerPeriodicalFundsContributions: state.brokerPeriodicalFundsContributions,
    }),
    {
        fetchPeriodicalContributions: BrokerPeriodicalFundsContributionsActions.fetchPeriodicalContributions,
        resetCancelPeriodicalContribution: BrokerPeriodicalFundsContributionsActions.resetCancelPeriodicalContribution,
    }
  )(ContributionManagmentCancelView)
);
